import React, { useEffect, useState, useContext } from "react";
import { dictionaryService, userService } from "../../services/api"; // Adjust path as needed
import { AuthContext } from "../../context/AuthContext";

const CommentsList = () => {
  const [comments, setComments] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1); // New state for page
  const [hasMore, setHasMore] = useState(true); // Optional: to disable next when no more pages

  const { currentUser } = useContext(AuthContext);

  const fetchComments = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await dictionaryService.getComments({
        page: pageNumber,
      });
      const comments = response.data || {};
      console.log("Fetched comments:", comments);
      setComments(comments.results || comments);
      setHasMore(comments.next !== null); // Optional: if API provides a `next` field
    } catch (error) {
      console.error("Error fetching users:", error);
      setComments([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (currentUser) {
      setIsAdmin(currentUser.profile.role === "admin");
    }
  }, [currentUser]);

  useEffect(() => {
    if (isAdmin) {
      fetchComments(page);
    }
  }, [isAdmin, page]);

  if (loading) return <div>Loading...</div>;

  if (!isAdmin) return <div>Access denied. Admins only.</div>;

  return (
    <div style={{ padding: "150px" }}>
      <h2>Users List</h2>
      <table border="1" cellPadding="8" cellSpacing="0">
        <thead>
          <tr>
            <th>Comment ID</th>
            <th>Comment Text</th>
            <th>Entry ID</th>
            <th>Entry Word</th>
            <th>User ID</th>
            <th>Username</th>
            <th>User Role</th>
          </tr>
        </thead>
        <tbody>
          {comments && comments.length > 0 ? (
            comments.map((user) => (
              <tr key={user.id || user._id}>
                <td>{user.id || user._id}</td>
                <td>{user.comment}</td>
                <td>{user.entry.id}</td>
                <td>{user.entry.word}</td>
                <td>{user.user.id}</td>
                <td>{user.user_username}</td>
                <td>{user.user.profile.role}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No users found.</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div style={{ marginTop: "16px" }}>
        <button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          Previous
        </button>
        <span style={{ margin: "0 10px" }}>Page {page}</span>
        <button onClick={() => setPage((prev) => prev + 1)} disabled={!hasMore}>
          Next
        </button>
      </div>
    </div>
  );
};

export default CommentsList;
